import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import getExchangeRates from 'domains/rates/getExchangeRates';
import Section from 'components/structure/Section';
import { maybeFormatPrefixedMessage } from 'utils/i18nUtils';
import Block from 'components/structure/Block/Block';
import TableRow from 'screens/OpenData/patterns/TableRow/TableRow';

function SectionExchangeRate() {
  const intl = useIntl();
  const myRatesFormatMessage = maybeFormatPrefixedMessage(intl, 'OPEN_DATA');
  const [exchangeRates, setExchangeRates] = useState([]);

  useEffect(() => {
    async function exchangeRatesEffect() {
      setExchangeRates(await getExchangeRates());
    }

    exchangeRatesEffect();
  }, []);

  const [firstItem] = exchangeRates;

  return (
    <Section minHeight="auto">
      <Block
        alignItems="center"
        textAlign="center"
        blockWidth="100%"
      >
        <Typography
          color="black"
          colorVariant="default"
          variant="title"
          gutterBottom={2}
          intlKey="OPEN_DATA.EXCHANGE_RATE_TABLE.TITTLE"
          intlValues={{ br: <br /> }}
        />
        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={1}
          intlKey="OPEN_DATA.EXCHANGE_RATE_TABLE.DESC"
        />
        {firstItem && (
        <>
          <Typography
            intlKey="OPEN_DATA.EXCHANGE_RATE_TABLE.LAST_UPDATE"
            intlValues={{
              date: intl.formatDate(firstItem.taxaDivulgacaoDataHora),
            }}
            variant="paragraph2"
          />
        </>
        )}
      </Block>
      <Block blockWidth="100%">
        <TableRow
          title={myRatesFormatMessage('EXCHANGE_RATE_TABLE.DATE')}
          value={myRatesFormatMessage('EXCHANGE_RATE_TABLE.RATE')}
          typographyProps={{
            variant: 'paragraph2',
          }}
        />
        {exchangeRates.map(({ taxaData, taxaConversao }) => (
          <TableRow
            key={taxaData}
            title={intl.formatDate(`${taxaData}T10:00`)}
            value={taxaConversao}
          />
        ))}
      </Block>
    </Section>
  );
}

export default React.memo(SectionExchangeRate);
